import React from 'react'
import Add500Tokens from '../Add500Tokens'

function Explain500({
    auth
}) {
    return (
        <div className="w-full border-2 border-gray-200 rounded-lg">
            <div
            style={{
                textAlign: 'center',
                backgroundColor:'#D4D4D4',
                padding: 10,
                margin: 0,
                fontSize: 'xx-large',
                fontWeight: 500,
                color: 'black'
            }}
            >
                Professional
            </div>
            <div
            style={{
                padding: 30,
                paddingBottom: 15,
                textAlign: 'center',
                fontSize: '69px',
                fontWeight: 500,
            }}
            >
                $100
                <p
                style={{
                    fontSize:'20px',
                    padding: 0,
                    paddingBottom: 0
                }}
                >
                    /month
                </p>
            </div>
            <div
            style={{
                padding: 20,
                paddingTop: 19,
                paddingBottom: 0,
                textAlign: 'center'
            }}
            >
                <b>500 tokens</b> for personalized outreach
                <br></br>
                <p
                style={{
                    fontSize: '11px'
                }}
                >
                (1 token = 1 personal message generated)
                </p>
                <br />
                <b>Unlimited</b> Prospect Lookups
                <br></br>
                <br></br>
                <b>Tokens Rollover</b> Each Month
            </div>
            <div
            style={{
                textAlign: 'center',
                padding: 10
            }}
            >
               <Add500Tokens 
               auth={auth}
               />
            </div>
        </div>
    )
}

export default Explain500
